import { useTheme } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { sharedStyles } from 'lib';
import React from 'react';

export const DataTrendIcon = ({
    trendDirection,
}: {
    trendDirection?: string;
}): React.JSX.Element => {
    const theme = useTheme();

    const styles = {
        iconBase: {
            opacity: 0.5,
            mr: 2,
            borderRadius: 3,
            color: theme.palette.background.paper,
        },
    };

    switch (trendDirection) {
        case 'up':
            return (
                <ArrowDropUpIcon
                    sx={{
                        ...styles.iconBase,
                        background: theme.palette.success.light,
                    }}
                />
            );
        case 'down':
            return (
                <ArrowDropDownIcon
                    sx={{
                        ...styles.iconBase,
                        ...sharedStyles.error,
                    }}
                />
            );
        default:
            return <div />;
    }
};
